export default __webpack_public_path__ + "static/media/beet_soup.66b9f485.jpg";